export const NAME = 'profile';